import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const MAX_CACHE_SIZE = 10;
const scrollCache = new Map();

function saveScroll(pathname, y) {
  scrollCache.delete(pathname); // move to end (most recent)
  scrollCache.set(pathname, y);
  if (scrollCache.size > MAX_CACHE_SIZE) {
    // Drop the least recently used entry (first key)
    scrollCache.delete(scrollCache.keys().next().value);
  }
}

function getScroll(pathname) {
  return scrollCache.get(pathname);
}

let currentPathname = "";
let isRestoringScroll = false; // Flag to prevent saving during restoration

function ScrollManager() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  // remember previous pathname so we don't treat search/query changes as route changes
  const prevPathnameRef = useRef(pathname);

  // Single persistent scroll listener
  useEffect(() => {
    const handleScroll = () => {
      // Don't save scroll position while we're restoring
      if (!isRestoringScroll) {
        //scrollCache.set(currentPathname, window.scrollY);
        saveScroll(currentPathname, window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Update current pathname reference
  useEffect(() => {
    currentPathname = pathname;
  }, [pathname]);

  // Handle navigation
  useEffect(() => {
    const prevPathname = prevPathnameRef.current;
    if (
      pathname !== prevPathname &&
      (navigationType === "PUSH" || navigationType === "REPLACE")
    ) {
      // Scroll to top for new navigation
      window.scrollTo(0, 0);
    }

    if (navigationType === "POP" && getScroll(pathname) !== undefined) {
      // Going back - restore previous scroll position
      isRestoringScroll = true;
      requestAnimationFrame(() => {
        const savedScroll = getScroll(pathname);
        window.scrollTo(0, savedScroll || 0);
        setTimeout(() => {
          isRestoringScroll = false;
        }, 100);
      });
    }

    prevPathnameRef.current = pathname;
  }, [pathname, navigationType]);

  return null;
}
export default ScrollManager;
